import { Grid } from "@mui/material";
import IconHolder from "./components/IconHolder";
import React from "react";
import Box from "ReusableComponents/Box";
import { HOST } from "api/apiClient";

const AboutUsFeatures = ({ features, small, medium }) => {
  return (
    <Box margin="0 0 80px 0">
      <Grid container spacing={2}>
        {features.map((item) => (
          <Grid item xs={6} md={3} key={item.id}>
            <IconHolder
              title={item?.attributes?.title}
              img={HOST + item?.attributes?.media?.data?.attributes?.url}
              small={small}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AboutUsFeatures;
